import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from 'store/appStore';
import { fetchSubmit } from 'action/submitAction';
import { selectAccessCode, selectSubmitId } from 'selector/navigationSelector';

export const useFetchSubmit = () => {
  const dispatch = useAppDispatch();
  const submitId = useSelector(selectSubmitId);
  const accessCode = useSelector(selectAccessCode);

  useEffect(() => {
    if (submitId) {
      dispatch(fetchSubmit());
    }
  }, [submitId, dispatch]);

  useEffect(() => {
    if (accessCode) {
      dispatch(fetchSubmit());
    }
  }, [accessCode, dispatch]);
};
